import Home from './pages/Home';
import React from 'react';

import './App.css';

function App() {
  return <div>
      <Home />
     </div>;

}

export default App;
